import React, {
  useState,
  createContext,
  useContext,
  FC,
  ReactNode,
} from "react";

type GoodCareFields = {
  name: string;
  id: string;
};

type GoodCareType = {
  SPECIAL_CONDITION: GoodCareFields[];
  SPECIAL_CARE: GoodCareFields[];
  TYPE_OF_GOODS: GoodCareFields[];
};

const initialGoodCareList: GoodCareType = {
  SPECIAL_CONDITION: [],
  SPECIAL_CARE: [],
  TYPE_OF_GOODS: [],
};

type DeliveryServiceFields = {
  label: string;
  value: string;
};

interface OrderFormStatesProps {
  goodCareConditionList: GoodCareType;
  setGoodCareConditionList: React.Dispatch<React.SetStateAction<GoodCareType>>;

  locationList: any[];
  setLocationList: React.Dispatch<React.SetStateAction<any[]>>;

  doesPostcodeExist: boolean;
  setDoesPostcodeExist: React.Dispatch<React.SetStateAction<boolean>>;

  deliveryServiceTypes: DeliveryServiceFields[];
  setDeliveryServiceTypes: React.Dispatch<
    React.SetStateAction<DeliveryServiceFields[]>
  >;

  customerList: any[];
  setCustomerList: React.Dispatch<React.SetStateAction<any[]>>;

  estimatedOrder: any;
  setEstimatedOrder: React.Dispatch<React.SetStateAction<any>>;

  orderEditDetail: any;
  setOrderEditDetail: React.Dispatch<React.SetStateAction<any>>;

  showPrompt: boolean;
  setShowPrompt: React.Dispatch<React.SetStateAction<boolean>>;

  filters: any;
  setFilters: React.Dispatch<React.SetStateAction<any>>;

  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;

  estimatedDeliveryDays: any
  setEstimatedDeliveryDays: React.Dispatch<React.SetStateAction<any>>;
}

interface OrderFormProviderProps {
  children: ReactNode;
}

const OrderFormContext = createContext<OrderFormStatesProps | undefined>(
  undefined,
);

export const OrderFormProvider: FC<OrderFormProviderProps> = ({ children }) => {
  const [goodCareConditionList, setGoodCareConditionList] =
    useState<GoodCareType>(initialGoodCareList);
  const [locationList, setLocationList] = useState<any[]>([]);
  const [doesPostcodeExist, setDoesPostcodeExist] = useState<boolean>(true);
  const [deliveryServiceTypes, setDeliveryServiceTypes] = useState<
    DeliveryServiceFields[]
  >([]);
  const [customerList, setCustomerList] = useState<any[]>([]);
  const [estimatedOrder, setEstimatedOrder] = useState<any>({});
  const [orderEditDetail, setOrderEditDetail] = useState<any>({});
  const [estimatedDeliveryDays, setEstimatedDeliveryDays] = useState<any>({})
  const [showPrompt, setShowPrompt] = useState<boolean>(false);

  const [filters, setFilters] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <OrderFormContext.Provider
      value={{
        goodCareConditionList,
        setGoodCareConditionList,
        locationList,
        setLocationList,
        doesPostcodeExist,
        setDoesPostcodeExist,
        deliveryServiceTypes,
        setDeliveryServiceTypes,
        customerList,
        setCustomerList,
        estimatedOrder,
        setEstimatedOrder,
        orderEditDetail,
        setOrderEditDetail,
        showPrompt,
        setShowPrompt,
        filters,
        setFilters,
        isLoading,
        setIsLoading,
        estimatedDeliveryDays,
        setEstimatedDeliveryDays
      }}
    >
      {children}
    </OrderFormContext.Provider>
  );
};

const useOrderFormStates = () => {
  const context = useContext(OrderFormContext);

  if (context === undefined) {
    throw new Error("OrderFormProvider not found.");
  }
  return context;
};

export default useOrderFormStates;
